import {
  CartsUpdatePetRakunoriRequestServicesPetDetailInnerCage,
  ContactsRepresentative,
  CreateCartResponse,
} from 'src/sdk-reservation';
import { RamlServicesMealPassengerAppliedMeal } from '@common/interfaces';
import { CurrentCartState, CurrentPlanModel, CurrentPlanState } from '@common/store';
import { TestData_PASSENGER as PASS } from '../passenger-test-data';
import { TestData_BOUND as BOUND } from '../bound-test-data';

const testBound1 = {
  id: 'EAI-X-OFF',
  cabin: 'eco',
  departureDaysDifferenceByBound: 1,
  arrivalDaysDifferenceByFlight: 1,
  connectionTime: 36000,
  isMultiAirportConnection: false,
  marketingAirlineCode: 'NH',
  marketingFlightNumber: '123',
  operatingAirlineCode: 'AF',
  operatingAirlineName: 'Air France',
  departure: {
    gate: '20',
    terminal: 'T1',
    estimatedDateTime: '2024-01-01T23:59:59',
    country2letterCode: 'JP',
    locationName: 'TOKYO INTL HANEDA',
    dateTime: '2023-12-31T23:59:59',
    locationCode: 'HND',
    iataAreaCode: 'TC3',
  },
  arrival: {
    gate: '20',
    terminal: 'T1',
    estimatedDateTime: '2024-01-01T23:59:59',
    country2letterCode: 'HK',
    locationName: 'TOKYO INTL HANEDA',
    dateTime: '2023-12-31T23:59:59',
    locationCode: 'HND',
    iataAreaCode: 'TC3',
  },
  aircraftCode: '777',
  aircraftName: 'BOEING 777-200/300',
  duration: 6000,
  isLateNightDeparture: false,
  isOpenSegment: false,
  isSubjectToGovernmentApproval: false,
  stops: [
    {
      locationCode: 'HNL',
      locationName: 'DANIEL K INOUYE INTL',
    },
  ],
  aircraftConfigurationVersion: 'DUM',
  flightServices: {
    isLoungeAvailable: true,
  },
  isStarAllianceOperated: true,
  isNhGroupMarketing: true,
  isNhGroupOperated: false,
  fareInfos: {
    fareClass: 'GXRFU1',
  },
  upgradableCabins: ['ecoPremium', 'business'],
  isJapanDomesticFlight: false,
  estimatedArrivalDaysDifferenceByFlight: 1,
};

const testFlight = {
  id: 'EAI-X-OFF',
  cabin: 'eco',
  departureDaysDifferenceByBound: 1,
  arrivalDaysDifferenceByFlight: 1,
  connectionTime: 36000,
  isMultiAirportConnection: false,
  marketingAirlineCode: 'NH',
  marketingFlightNumber: '123',
  operatingAirlineCode: 'NH',
  operatingAirlineName: 'ALL NIPPON AIRWAYS',
  departure: {
    gate: '20',
    terminal: 'T1',
    estimatedDateTime: '2024-01-01T23:59:59',
    country2letterCode: 'JP',
    locationName: 'TOKYO INTL HANEDA',
    dateTime: '2023-12-31T23:59:59',
    locationCode: 'HND',
    iataAreaCode: 'TC3',
  },
  arrival: {
    gate: '20',
    terminal: 'T1',
    estimatedDateTime: '2024-01-01T23:59:59',
    country2letterCode: 'HK',
    locationName: 'TOKYO INTL HANEDA',
    dateTime: '2023-12-31T23:59:59',
    locationCode: 'HND',
    iataAreaCode: 'TC3',
  },
  aircraftCode: '777',
  aircraftName: 'BOEING 777-200/300',
  duration: 6000,
  isLateNightDeparture: false,
  isOpenSegment: false,
  isSubjectToGovernmentApproval: false,
  stops: [
    {
      locationCode: 'HNL',
      locationName: 'DANIEL K INOUYE INTL',
    },
  ],
  aircraftConfigurationVersion: 'DUM',
  flightServices: {
    isLoungeAvailable: true,
  },
  isStarAllianceOperated: true,
  isNhGroupMarketing: true,
  isNhGroupOperated: false,
  fareInfos: {
    fareClass: 'GXRFU1',
  },
  upgradableCabins: ['ecoPremium', 'business'],
  isJapanDomesticFlight: false,
  estimatedArrivalDaysDifferenceByFlight: 1,
};

const testBaggage = {
  isAvailable: true,
  'SKH-XX-EXT': {
    serviceStatus: 'requested',
    isAvailable: true,
    prices: {
      total: 10000,
      currencyCode: 'JPY',
    },
    catalogue: {
      prices: {
        total: 11000,
        currencyCode: 'JPY',
      },
    },
  },
  'SKH-XX-EXT2': {
    serviceStatus: 'requested',
    isAvailable: true,
    prices: {
      total: 10000,
      currencyCode: 'JPY',
    },
    catalogue: {
      prices: {
        total: 11000,
        currencyCode: 'JPY',
      },
    },
  },
};

const testLounge = {
  isAvailable: true,
  'SKH-XX-EXT': {
    code: '',
    statusCode: 'HK',
    serviceStatus: 'requested',
    isWaived: false,
    isAvailable: true,
    prices: {
      total: 20000,
      currencyCode: 'JPY',
    },
    catalogue: [
      {
        code: 'MYLG',
        quota: '3',
        prices: {
          total: 3000,
          currencyCode: 'JPY',
        },
      },
    ],
  },
};

const testMeal = {
  isAvailable: true,
  isExpired: true,
  'SKH-XX-EXT': {
    appliedMealList: [],
  },
};

export const PlanReviewTestCart1: CurrentCartState = {
  warnings: [],
  data: {
    plan: {
      prices: {
        unitPrices: {
          'SKH-XX-EXT': {
            ticketPrices: {
              total: 111.11,
              base: 111.11,
              currencyCode: 'USD',
              airTransportationCharges: 111.11,
              thirdPartyCharges: 111.11,
              totalTaxes: 111.11,
              totalFlightSurcharges: 111.11,
              discount: {
                originalTotal: 123.12,
              },
              taxes: [
                {
                  code: 'ABC',
                  value: 111.11,
                  currencyCode: 'USD',
                },
                {
                  code: 'XXX',
                  value: 111.11,
                  currencyCode: 'USD',
                },
              ],
              fuelSurcharge: {
                value: 111.11,
                currencyCode: 'USD',
              },
              insuranceSurcharge: {
                value: 111.11,
                currencyCode: 'USD',
              },
              flightSurcharge: {
                value: 111.11,
                currencyCode: 'USD',
              },
              ticketingFee: {
                value: 111.11,
                currencyCode: 'USD',
              },
            },
            servicePrices: {
              lounge: {
                value: 111.11,
                currencyCode: 'USD',
              },
              firstBaggage: {
                value: 111.11,
                currencyCode: 'USD',
              },
              meal: {
                value: 111.11,
                currencyCode: 'USD',
              },
            },
            serviceTaxes: [
              {
                code: 'SS',
                value: 111.11,
                currencyCode: 'USD',
              },
              {
                code: '01',
                value: 111.11,
                currencyCode: 'USD',
              },
            ],
          },
        },
        totalPrices: {
          ticketPrices: {
            base: {
              value: 111.11,
              currencyCode: 'USD',
            },
            totalTaxes: {
              code: '00',
              value: 111.11,
              currencyCode: 'USD',
            },
            airTransportationCharges: {
              value: 111.11,
              currencyCode: 'USD',
            },
            thirdPartyCharges: {
              value: 111.11,
              currencyCode: 'USD',
            },
            totalFlightSurcharges: 111.11,
          },
          servicePrices: {
            total: {
              value: 111.11,
              currencyCode: 'USD',
            },
            totalTaxes: {
              code: '00',
              value: 111.11,
              currencyCode: 'USD',
            },
          },
          total: {
            value: 111.12,
            currencyCode: 'USD',
          },
          discount: {
            originalTotal: 123.12,
            aamDiscountCode: 'AAM TEST',
            cat25DiscountName: '',
          },
        },
      },
      airOfferIds: [
        {
          cartAirOfferId: 'OFF-1-OFF',
          offerNdcId: 'SR1V-XXXXXXXX-X',
        },
      ],
      airOffer: {
        bounds: [
          {
            airBoundId: 'ID001',
            originLocationCode: 'HND',
            destinationLocationCode: 'LAX',
            originLocationName: 'TOKYO INTL HANEDA',
            originDepartureDateTime: '2023-12-01T10:00:00',
            originDepartureEstimatedDateTime: '2023-12-01T10:00:00',
            destinationLocationName: 'LOS ANGELES INTL',
            destinationArrivalDateTime: '2024-01-01T10:00:00',
            destinationArrivalEstimatedDateTime: '2024-01-01T10:00:00',
            destinationArrivalDaysDifference: 1,
            destinationArrivalEstimatedDaysDifference: 2,
            flights: [
              {
                id: 'EAI-X-OFF',
                cabin: 'business',
                bookingClass: 'B',
                departureDaysDifferenceByBound: 1,
                arrivalDaysDifferenceByFlight: 1,
                connectionTime: 36000,
                isMultiAirportConnection: false,
                marketingAirlineCode: 'NH',
                marketingFlightNumber: '123',
                operatingAirlineCode: 'NH',
                operatingAirlineName: 'ALL NIPPON AIRWAYS',
                departure: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2023-12-31T23:59:58',
                  country2letterCode: 'JP',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-01T22:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                arrival: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'HK',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                aircraftCode: '777',
                aircraftName: 'BOEING 777-200/300',
                duration: 6000,
                isLateNightDeparture: false,
                isOpenSegment: false,
                isSubjectToGovernmentApproval: true,
                stops: [
                  {
                    locationCode: 'HNL',
                    locationName: 'DANIEL K INOUYE INTL',
                  },
                  {
                    locationCode: 'CDG',
                    locationName: 'Charles de Gaule',
                  },
                ],
                aircraftConfigurationVersion: 'DUM',
                flightServices: {
                  isLoungeAvailable: true,
                },
                isStarAllianceOperated: true,
                isNhGroupMarketing: true,
                isNhGroupOperated: true,
                fareInfos: {
                  fareClass: 'GXRFU1',
                },
                upgradableCabins: ['ecoPremium', 'business'],
                isJapanDomesticFlight: false,
                estimatedArrivalDaysDifferenceByFlight: -1,
              },
              {
                id: 'EAI-X-OFF2',
                cabin: 'eco',
                departureDaysDifferenceByBound: 1,
                arrivalDaysDifferenceByFlight: 1,
                connectionTime: 36000,
                isMultiAirportConnection: false,
                marketingAirlineCode: 'NH',
                marketingFlightNumber: '123',
                operatingAirlineCode: 'AF',
                operatingAirlineName: 'Air France',
                departure: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'JP',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                arrival: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'HK',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                aircraftCode: '777',
                aircraftName: 'BOEING 777-200/300',
                duration: 6000,
                isLateNightDeparture: false,
                isOpenSegment: false,
                isSubjectToGovernmentApproval: false,
                stops: [
                  {
                    locationCode: 'HNL',
                    locationName: 'DANIEL K INOUYE INTL',
                  },
                ],
                aircraftConfigurationVersion: 'DUM',
                flightServices: {
                  isLoungeAvailable: true,
                },
                isStarAllianceOperated: true,
                isNhGroupMarketing: true,
                isNhGroupOperated: false,
                fareInfos: {
                  fareClass: 'GXRFU1',
                },
                upgradableCabins: ['ecoPremium', 'business'],
                isJapanDomesticFlight: false,
                estimatedArrivalDaysDifferenceByFlight: 1,
              },
            ],
            duration: 6000,
            isOtherMethodsConnection: true,
            isContainedDelayedFlight: false,
            isContainedEarlyDepartureFlight: false,
            numberOfConnections: 1,
            operatingAirlines: [
              {
                airlineCode: 'NH',
                airlineName: 'ALL NIPPON AIRWAYS',
              },
            ],
            isAllStarAllianceOperated: true,
            isAllNhGroupOperated: true,
            isContainedSubjectToGovernmentApproval: true,
            isContainedWaitlisted: true,
          },
          {
            airBoundId: 'ID002',
            originLocationCode: 'HND',
            destinationLocationCode: 'LAX',
            originLocationName: 'TOKYO INTL HANEDA',
            originDepartureDateTime: '2023-12-01T10:00:00',
            originDepartureEstimatedDateTime: '2023-12-01T10:00:00',
            destinationLocationName: 'LOS ANGELES INTL',
            destinationArrivalDateTime: '2024-01-01T10:00:00',
            destinationArrivalEstimatedDateTime: '2024-01-01T10:00:00',
            destinationArrivalDaysDifference: 1,
            destinationArrivalEstimatedDaysDifference: 2,
            flights: [
              {
                id: 'EAI-X-OFF',
                cabin: 'eco',
                departureDaysDifferenceByBound: 1,
                arrivalDaysDifferenceByFlight: 1,
                connectionTime: 36000,
                isMultiAirportConnection: false,
                marketingAirlineCode: 'NH',
                marketingFlightNumber: '123',
                operatingAirlineCode: 'NH',
                operatingAirlineName: 'ALL NIPPON AIRWAYS',
                departure: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'JP',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                arrival: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'HK',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                aircraftCode: '777',
                aircraftName: 'BOEING 777-200/300',
                duration: 6000,
                isLateNightDeparture: false,
                isOpenSegment: false,
                isSubjectToGovernmentApproval: false,
                stops: [
                  {
                    locationCode: 'HNL',
                    locationName: 'DANIEL K INOUYE INTL',
                  },
                ],
                aircraftConfigurationVersion: 'DUM',
                flightServices: {
                  isLoungeAvailable: true,
                },
                isStarAllianceOperated: true,
                isNhGroupMarketing: true,
                isNhGroupOperated: false,
                fareInfos: {
                  fareClass: 'GXRFU1',
                },
                upgradableCabins: ['ecoPremium', 'business'],
                isJapanDomesticFlight: false,
                estimatedArrivalDaysDifferenceByFlight: 1,
              },
            ],
            duration: 6000,
            isOtherMethodsConnection: false,
            isContainedDelayedFlight: false,
            isContainedEarlyDepartureFlight: false,
            numberOfConnections: 1,
            operatingAirlines: [
              {
                airlineCode: 'NH',
                airlineName: 'ALL NIPPON AIRWAYS',
              },
            ],
            isAllStarAllianceOperated: true,
            isAllNhGroupOperated: true,
            isContainedSubjectToGovernmentApproval: true,
            isContainedWaitlisted: true,
          },
          { ...testBound1, airBoundId: 'ID003', flights: [{ ...testFlight, id: 'EAI-X-OFF3' }] },
          { ...testBound1, airBoundId: 'ID004', flights: [{ ...testFlight, id: 'EAI-X-OFF4' }] },
          { ...testBound1, airBoundId: 'ID005', flights: [{ ...testFlight, id: 'EAI-X-OFF5' }] },
          { ...testBound1, airBoundId: 'ID006', flights: [{ ...testFlight, id: 'EAI-X-OFF5' }] },
        ],
        accrualMiles: 111,
        fareFamilyWithService: {
          priorityCode: 11,
        },
        existsTravelSkyHostedAirline: true,
        tripType: 'international',
      },
      services: {
        baggage: {
          firstBaggage: {
            'BND-1': {
              isAvailable: true,
              'SKH-XX-EXT': {
                serviceStatus: 'requested',
                isAvailable: true,
                prices: {
                  total: 10000,
                  currencyCode: 'JPY',
                },
                catalogue: {
                  prices: {
                    total: 11000,
                    currencyCode: 'JPY',
                  },
                },
              },
              'SKH-XX-EXT2': {
                serviceStatus: 'requested',
                isAvailable: true,
                prices: {
                  total: 10000,
                  currencyCode: 'JPY',
                },
                catalogue: {
                  prices: {
                    total: 11000,
                    currencyCode: 'JPY',
                  },
                },
              },
            },
            'BND-2': testBaggage,
            'BND-3': testBaggage,
            'BND-4': testBaggage,
            'BND-5': testBaggage,
          },
        },
        lounge: {
          'EAI-X-OFF': {
            isAvailable: true,
            'SKH-XX-EXT': {
              code: 'LOUG',
              statusCode: 'HK',
              serviceStatus: 'requested',
              isWaived: false,
              isAvailable: true,
              prices: {
                total: 20000,
                currencyCode: 'JPY',
              },
              catalogue: [
                {
                  code: 'MYLG',
                  quota: '3',
                  prices: {
                    total: 3000,
                    currencyCode: 'JPY',
                  },
                },
              ],
            },
          },
          'EAI-X-OFF2': testLounge,
          'EAI-X-OFF3': testLounge,
          'EAI-X-OFF4': testLounge,
          'EAI-X-OFF5': testLounge,
        },
        meal: {
          'EAI-X-OFF': {
            isAvailable: true,
            isExpired: false,
            'SKH-XX-EXT': {
              appliedMealList: [
                {
                  code: 'CAML',
                  id: 'XXXXXX',
                  type: 'ancillary',
                  preOrderMealMessageId: 'XXXXXXXXXX',
                  serviceStatus: 'requested',
                  price: {
                    total: 2501,
                    currencyCode: 'JPY',
                  },
                },
              ],
            },
            'SKH-XX-EXT2': {
              appliedMealList: [
                {
                  code: 'VGML',
                  id: 'XXXXXX',
                  type: 'preOrder',
                  preOrderMealMessageId: 'label.preorder.wfml',
                  serviceStatus: 'requested',
                  price: {},
                },
              ],
            },
          },
          'EAI-X-OFF2': testMeal,
          'EAI-X-OFF3': testMeal,
          'EAI-X-OFF4': testMeal,
          'EAI-X-OFF5': testMeal,
        },
      },
      chargeableAncillarySummary: {
        ID001: {
          firstBaggage: {
            numberOfRequests: 1,
          },
          lounge: {
            numberOfRequests: 1,
          },
          meal: {
            numberOfRequests: 1,
          },
        },
        ID002: {
          firstBaggage: {
            numberOfRequests: 1,
          },
          lounge: {
            numberOfRequests: 1,
          },
          meal: {
            numberOfRequests: 1,
          },
        },
        ID003: {
          firstBaggage: {
            numberOfRequests: 1,
          },
          lounge: {
            numberOfRequests: 1,
          },
          meal: {
            numberOfRequests: 1,
          },
        },
        ID004: {
          firstBaggage: {
            numberOfRequests: 1,
          },
          lounge: {
            numberOfRequests: 1,
          },
          meal: {
            numberOfRequests: 1,
          },
        },
        ID005: {
          firstBaggage: {
            numberOfRequests: 1,
          },
          lounge: {
            numberOfRequests: 1,
          },
          meal: {
            numberOfRequests: 1,
          },
        },
        ID006: {
          firstBaggage: {
            numberOfRequests: 1,
          },
          lounge: {
            numberOfRequests: 1,
          },
          meal: {
            numberOfRequests: 1,
          },
        },
      },
      contacts: {
        representative: {
          emails: [
            {
              address: 'XXX_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'XXX*********************',
            },
          ],
          phones: [
            {
              type: 'M',
              countryPhoneExtension: '81',
              number: '312345678',
              encryptedNumber: '******678',
            },
          ],
          contactsDuringStay: [
            {
              id: 'AP-XX-PNR',
              number: 'XXXX HOTEL',
            },
          ],
        } as ContactsRepresentative,
        upgradeNotification: {
          emails: [
            {
              id: 'OT18',
              address: 'XXX_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'XXX*********************',
            },
          ],
        },
        'SKH-XX-EXT': {
          emails: [
            {
              address: 'AAA_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'AAA*********************',
              isSameAsRepresentative: true,
            },
          ],
          phones: [
            {
              countryPhoneExtension: '81',
              number: '987654321',
              encryptedNumber: '*****321',
              isSameAsRepresentative: false,
            },
          ],
          departureArrivalNotifications: [
            {
              emails: [
                {
                  address: 'BBB_XXXXXX@ANASYSTEMS.CO.JP',
                  recipient: 'XXXXXXXX',
                  lang: 'JA',
                },
              ],
              isRegisteredEmail: true,
            },
          ],
        },
        'SKH-XX-EXT2': {
          emails: [
            {
              address: 'AAA_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'AAA*********************',
              isSameAsRepresentative: true,
            },
          ],
          phones: [
            {
              countryPhoneExtension: '81',
              number: '987654321',
              encryptedNumber: '*****321',
              isSameAsRepresentative: true,
            },
          ],
          departureArrivalNotifications: [
            {
              emails: [
                {
                  address: 'BBB_XXXXXX@ANASYSTEMS.CO.JP',
                  recipient: 'XXXXXXXX',
                  lang: 'JA',
                },
              ],
              isRegisteredEmail: false,
            },
          ],
        },
      },
      travelers: [
        {
          id: 'SKH-XX-EXT',
          names: [
            {
              title: 'MR',
              firstName: 'E',
              middleName: 'B',
              lastName: 'SORAYAMA',
            },
          ],
          passengerTypeCode: 'ADT',
          accompanyingTravelerId: 'SKH-XX-EXT',
          dateOfBirth: '1999/01/01',
          encryptedDateOfBirth: '****/**/**',
          gender: 'male',
          regulatoryDetails: {
            passports: [
              {
                number: 'XXXXXXXXXXXXX',
              },
            ],
            isPassportRegistered: true,
          },
        },
        {
          id: 'SKH-XX-EXT2',
          names: [
            {
              title: 'MR',
              firstName: '',
              middleName: '',
              lastName: '',
            },
          ],
          passengerTypeCode: 'B15',
          accompanyingTravelerId: 'SKH-XX-EXT',
          dateOfBirth: '1999/01/01',
          gender: 'male',
          regulatoryDetails: {
            passports: [
              {
                number: 'XXXXXXXXXXXXX',
              },
            ],
          },
        },
        {
          id: 'SKH-XX-EXT3',
          names: [
            {
              title: 'MR',
              firstName: 'BIGTARO',
              middleName: '',
              lastName: 'TAROTARO',
            },
          ],
          passengerTypeCode: 'ADT',
          accompanyingTravelerId: 'SKH-XX-EXT',
          dateOfBirth: '1999/01/01',
          gender: 'male',
          regulatoryDetails: {
            passports: [
              {
                number: 'XXXXXXXXXXXXX',
              },
            ],
          },
        },
        {
          id: 'SKH-XX-EXT4',
          names: [
            {
              title: 'MS',
              firstName: 'TAROKO',
              middleName: '',
              lastName: 'TAROTARO',
            },
          ],
          passengerTypeCode: 'INF',
          accompanyingTravelerId: '',
          dateOfBirth: '1999/01/01',
          gender: 'male',
          regulatoryDetails: {
            passports: [
              {
                number: 'XXXXXXXXXXXXX',
              },
            ],
          },
        },
        {
          id: 'SKH-XX-EXT5',
          names: [
            {
              title: 'MR',
              firstName: 'TARO',
              middleName: '',
              lastName: 'TAROTARO',
            },
          ],
          passengerTypeCode: 'CHD',
          accompanyingTravelerId: '',
          dateOfBirth: '1999/01/01',
          gender: 'male',
          regulatoryDetails: {
            passports: [
              {
                number: 'XXXXXXXXXXXXX',
              },
            ],
          },
        },
      ],
      travelersSummary: {
        isRegistered: true,
        numberOfTraveler: {
          ADT: 5,
          B15: 0,
          CHD: 0,
          INF: 2,
        },
      },
      cartEligibilities: {
        isTravelerSupportsEligible: true,
      },
      travelerSupports: {
        'SKH-XX-EXT2': {
          isSupportRegistered: true,
          blind: {
            isRequested: false,
          },
          deaf: {
            isRequested: false,
          },
        },
      },
      frequentFlyerCards: {
        'SKH-XX-EXT': {
          fqtv: {
            companyCode: 'NH',
            cardNumber: '9900000012',
          },
        },
      },
    },
    previousPlan: {
      prices: {
        unitPrices: {
          'SKH-XX-EXT': {
            ticketPrices: {
              total: 111.11,
              base: 111.11,
              currencyCode: 'USD',
              airTransportationCharges: 111.11,
              thirdPartyCharges: 111.11,
              totalTaxes: 111.11,
              totalFlightSurcharges: 111.11,
              discount: {
                originalTotal: 123.12,
              },
              taxes: [
                {
                  code: 'ABC',
                  value: 111.11,
                  currencyCode: 'USD',
                },
                {
                  code: 'XXX',
                  value: 111.11,
                  currencyCode: 'USD',
                },
              ],
              fuelSurcharge: {
                value: 111.11,
                currencyCode: 'USD',
              },
              insuranceSurcharge: {
                value: 111.11,
                currencyCode: 'USD',
              },
              flightSurcharge: {
                value: 111.11,
                currencyCode: 'USD',
              },
              ticketingFee: {
                value: 111.11,
                currencyCode: 'USD',
              },
            },
            servicePrices: {
              lounge: {
                value: 111.11,
                currencyCode: 'USD',
              },
              firstBaggage: {
                value: 111.11,
                currencyCode: 'USD',
              },
              meal: {
                value: 111.11,
                currencyCode: 'USD',
              },
            },
            serviceTaxes: [
              {
                code: 'SS',
                value: 111.11,
                currencyCode: 'USD',
              },
              {
                code: '01',
                value: 111.11,
                currencyCode: 'USD',
              },
            ],
          },
        },
        totalPrices: {
          ticketPrices: {
            base: {
              value: 111.11,
              currencyCode: 'USD',
            },
            totalTaxes: {
              code: '00',
              value: 111.11,
              currencyCode: 'USD',
            },
            airTransportationCharges: {
              value: 111.11,
              currencyCode: 'USD',
            },
            thirdPartyCharges: {
              value: 111.11,
              currencyCode: 'USD',
            },
            totalFlightSurcharges: 111.11,
          },
          servicePrices: {
            total: {
              value: 111.11,
              currencyCode: 'USD',
            },
            totalTaxes: {
              code: '00',
              value: 111.11,
              currencyCode: 'USD',
            },
          },
          total: {
            value: 111.11,
            currencyCode: 'USD',
          },
          discount: {
            originalTotal: 123.12,
            aamDiscountCode: 'AAM TEST',
            cat25DiscountName: '',
          },
        },
      },
      airOfferIds: [
        {
          cartAirOfferId: 'OFF-1-OFF',
          offerNdcId: 'SR1V-XXXXXXXX-X',
        },
      ],
      airOffer: {
        bounds: [
          {
            airBoundId: 'BND-1',
            originLocationCode: 'HND',
            destinationLocationCode: 'LAX',
            originLocationName: 'TOKYO INTL HANEDA',
            originDepartureDateTime: '2023-12-01T10:00:00',
            originDepartureEstimatedDateTime: '2023-12-01T10:00:00',
            destinationLocationName: 'LOS ANGELES INTL',
            destinationArrivalDateTime: '2024-01-01T10:00:00',
            destinationArrivalEstimatedDateTime: '2024-01-01T10:00:00',
            destinationArrivalDaysDifference: 1,
            destinationArrivalEstimatedDaysDifference: 2,
            flights: [
              {
                id: 'EAI-X-OFF',
                cabin: 'business',
                bookingClass: 'B',
                departureDaysDifferenceByBound: 1,
                arrivalDaysDifferenceByFlight: 1,
                connectionTime: 36000,
                isMultiAirportConnection: false,
                marketingAirlineCode: 'NH',
                marketingFlightNumber: '123',
                operatingAirlineCode: 'NH',
                operatingAirlineName: 'ALL NIPPON AIRWAYS',
                departure: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2023-12-31T23:59:59',
                  country2letterCode: 'JP',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-01T22:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                arrival: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'HK',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                aircraftCode: '777',
                aircraftName: 'BOEING 777-200/300',
                duration: 6000,
                isLateNightDeparture: false,
                isOpenSegment: false,
                isSubjectToGovernmentApproval: true,
                stops: [
                  {
                    locationCode: 'HNL',
                    locationName: 'DANIEL K INOUYE INTL',
                  },
                  {
                    locationCode: 'CDG',
                    locationName: 'Charles de Gaule',
                  },
                ],
                aircraftConfigurationVersion: 'DUM',
                flightServices: {
                  isLoungeAvailable: true,
                },
                isStarAllianceOperated: true,
                isNhGroupMarketing: true,
                isNhGroupOperated: true,
                fareInfos: {
                  fareClass: 'GXRFU1',
                },
                upgradableCabins: ['ecoPremium', 'business'],
                isJapanDomesticFlight: true,
                estimatedArrivalDaysDifferenceByFlight: -1,
              },
              {
                id: 'EAI-X-OFF2',
                cabin: 'eco',
                departureDaysDifferenceByBound: 1,
                arrivalDaysDifferenceByFlight: 1,
                connectionTime: 36000,
                isMultiAirportConnection: false,
                marketingAirlineCode: 'NH',
                marketingFlightNumber: '123',
                operatingAirlineCode: 'AF',
                operatingAirlineName: 'Air France',
                departure: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'JP',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                arrival: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'HK',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                aircraftCode: '777',
                aircraftName: 'BOEING 777-200/300',
                duration: 6000,
                isLateNightDeparture: false,
                isOpenSegment: false,
                isSubjectToGovernmentApproval: false,
                stops: [
                  {
                    locationCode: 'HNL',
                    locationName: 'DANIEL K INOUYE INTL',
                  },
                ],
                aircraftConfigurationVersion: 'DUM',
                flightServices: {
                  isLoungeAvailable: true,
                },
                isStarAllianceOperated: true,
                isNhGroupMarketing: true,
                isNhGroupOperated: false,
                fareInfos: {
                  fareClass: 'GXRFU1',
                },
                upgradableCabins: ['ecoPremium', 'business'],
                isJapanDomesticFlight: false,
                estimatedArrivalDaysDifferenceByFlight: 1,
              },
              { ...testBound1 },
            ],
            duration: 6000,
            isOtherMethodsConnection: true,
            isContainedDelayedFlight: false,
            isContainedEarlyDepartureFlight: false,
            numberOfConnections: 1,
            operatingAirlines: [
              {
                airlineCode: 'NH',
                airlineName: 'ALL NIPPON AIRWAYS',
              },
            ],
            isAllStarAllianceOperated: true,
            isAllNhGroupOperated: true,
            isContainedSubjectToGovernmentApproval: true,
            isContainedWaitlisted: true,
          },
          {
            airBoundId: 'BND-2',
            originLocationCode: 'HND',
            destinationLocationCode: 'LAX',
            originLocationName: 'TOKYO INTL HANEDA',
            originDepartureDateTime: '2023-12-01T10:00:00',
            originDepartureEstimatedDateTime: '2023-12-01T10:00:00',
            destinationLocationName: 'LOS ANGELES INTL',
            destinationArrivalDateTime: '2024-01-01T10:00:00',
            destinationArrivalEstimatedDateTime: '2024-01-01T10:00:00',
            destinationArrivalDaysDifference: 1,
            destinationArrivalEstimatedDaysDifference: 2,
            flights: [
              {
                id: 'EAI-X-OFF',
                cabin: 'eco',
                departureDaysDifferenceByBound: 1,
                arrivalDaysDifferenceByFlight: 1,
                connectionTime: 36000,
                isMultiAirportConnection: false,
                marketingAirlineCode: 'NH',
                marketingFlightNumber: '123',
                operatingAirlineCode: 'NH',
                operatingAirlineName: 'ALL NIPPON AIRWAYS',
                departure: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'JP',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                arrival: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'HK',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                aircraftCode: '777',
                aircraftName: 'BOEING 777-200/300',
                duration: 6000,
                isLateNightDeparture: false,
                isOpenSegment: false,
                isSubjectToGovernmentApproval: false,
                stops: [
                  {
                    locationCode: 'HNL',
                    locationName: 'DANIEL K INOUYE INTL',
                  },
                ],
                aircraftConfigurationVersion: 'DUM',
                flightServices: {
                  isLoungeAvailable: true,
                },
                isStarAllianceOperated: true,
                isNhGroupMarketing: true,
                isNhGroupOperated: false,
                fareInfos: {
                  fareClass: 'GXRFU1',
                },
                upgradableCabins: ['ecoPremium', 'business'],
                isJapanDomesticFlight: false,
                estimatedArrivalDaysDifferenceByFlight: 1,
              },
            ],
            duration: 6000,
            isOtherMethodsConnection: false,
            isContainedDelayedFlight: false,
            isContainedEarlyDepartureFlight: false,
            numberOfConnections: 1,
            operatingAirlines: [
              {
                airlineCode: 'NH',
                airlineName: 'ALL NIPPON AIRWAYS',
              },
            ],
            isAllStarAllianceOperated: true,
            isAllNhGroupOperated: true,
            isContainedSubjectToGovernmentApproval: true,
            isContainedWaitlisted: true,
          },
        ],
        accrualMiles: 111,
        fareFamilyWithService: {
          priorityCode: 11,
        },
        existsTravelSkyHostedAirline: true,
        tripType: 'international',
      },
      services: {
        baggage: {
          firstBaggage: {
            'BND-1': {
              isAvailable: true,
              'SKH-XX-EXT': {
                serviceStatus: 'requested',
                isAvailable: true,
                prices: {
                  total: 10000,
                  currencyCode: 'JPY',
                },
                catalogue: {
                  prices: {
                    total: 11000,
                    currencyCode: 'JPY',
                  },
                },
              },
            },
          },
        },
        lounge: {
          'EAI-X-OFF': {
            isAvailable: true,
            'SKH-XX-EXT': {
              code: 'LOUG',
              statusCode: 'HK',
              serviceStatus: 'requested',
              isWaived: false,
              isAvailable: false,
              prices: {
                total: 20000,
                currencyCode: 'JPY',
              },
              catalogue: [
                {
                  code: 'MYLG',
                  quota: '3',
                  prices: {
                    total: 3000,
                    currencyCode: 'JPY',
                  },
                },
              ],
            },
          },
          'EAI-X-OFF2': {
            isAvailable: true,
            'SKH-XX-EXT': {
              code: '',
              statusCode: 'HK',
              serviceStatus: 'requested',
              isWaived: true,
              isAvailable: true,
              prices: {
                total: 20000,
                currencyCode: 'JPY',
              },
              catalogue: [
                {
                  code: 'MYLG',
                  quota: '3',
                  prices: {
                    total: 3000,
                    currencyCode: 'JPY',
                  },
                },
              ],
            },
          },
        },
        meal: {
          'EAI-X-OFF': {
            isAvailable: true,
            isExpired: false,
            'SKH-XX-EXT': {
              appliedMealList: [
                {
                  code: 'CAML',
                  id: 'XXXXXX',
                  type: 'ancillary',
                  preOrderMealMessageId: 'XXXXXXXXXX',
                  serviceStatus: 'requested',
                  price: {
                    total: 2501,
                    currencyCode: 'JPY',
                  },
                },
              ],
            },
            'SKH-XX-EXT2': {
              appliedMealList: [],
            },
          },
          'EAI-X-OFF2': {
            isAvailable: true,
            isExpired: true,
            'SKH-XX-EXT': {
              appliedMealList: [],
            },
          },
        },
      },
      chargeableAncillarySummary: {
        'BND-1': {
          firstBaggage: {
            numberOfRequests: 1,
          },
          lounge: {
            numberOfRequests: 1,
          },
          meal: {
            numberOfRequests: 1,
          },
        },
      },
      contacts: {
        representative: {
          emails: [
            {
              address: 'XXX_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'XXX*********************',
            },
          ],
          phones: [
            {
              type: 'M',
              countryPhoneExtension: '81',
              number: '312345678',
              encryptedNumber: '******678',
            },
          ],
          contactsDuringStay: [
            {
              id: 'AP-XX-PNR',
              number: 'XXXX HOTEL',
            },
          ],
        } as ContactsRepresentative,
        upgradeNotification: {
          emails: [
            {
              id: 'OT18',
              address: 'XXX_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'XXX*********************',
            },
          ],
        },
        'SKH-XX-EXT': {
          emails: [
            {
              address: 'AAA_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'AAA*********************',
              isSameAsRepresentative: true,
            },
          ],
          phones: [
            {
              countryPhoneExtension: '81',
              number: '987654321',
              encryptedNumber: '*****321',
              isSameAsRepresentative: false,
            },
          ],
          departureArrivalNotifications: [
            {
              emails: [
                {
                  address: 'BBB_XXXXXX@ANASYSTEMS.CO.JP',
                  recipient: 'XXXXXXXX',
                  lang: 'JA',
                },
              ],
              isRegisteredEmail: true,
            },
          ],
        },
        'SKH-XX-EXT2': {
          emails: [
            {
              address: 'AAA_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'AAA*********************',
              isSameAsRepresentative: true,
            },
          ],
          phones: [
            {
              countryPhoneExtension: '81',
              number: '987654321',
              encryptedNumber: '*****321',
              isSameAsRepresentative: true,
            },
          ],
          departureArrivalNotifications: [
            {
              emails: [
                {
                  address: 'BBB_XXXXXX@ANASYSTEMS.CO.JP',
                  recipient: 'XXXXXXXX',
                  lang: 'JA',
                },
              ],
              isRegisteredEmail: false,
            },
          ],
        },
      },
      travelers: [
        {
          id: 'SKH-XX-EXT',
          names: [
            {
              title: 'MR',
              firstName: 'E',
              middleName: 'B',
              lastName: 'SORAYAMA',
            },
          ],
          passengerTypeCode: 'ADT',
          accompanyingTravelerId: 'SKH-XX-EXT',
          dateOfBirth: '1999/01/01',
          encryptedDateOfBirth: '****/**/**',
          gender: 'male',
          regulatoryDetails: {
            passports: [
              {
                number: 'XXXXXXXXXXXXX',
              },
            ],
            isPassportRegistered: true,
          },
        },
        {
          id: 'SKH-XX-EXT2',
          names: [
            {
              title: 'MR',
              firstName: '',
              middleName: '',
              lastName: '',
            },
          ],
          passengerTypeCode: 'B15',
          accompanyingTravelerId: 'SKH-XX-EXT',
          dateOfBirth: '1999/01/01',
          gender: 'male',
          regulatoryDetails: {
            passports: [
              {
                number: 'XXXXXXXXXXXXX',
              },
            ],
          },
        },
      ],
      travelersSummary: {
        isRegistered: true,
        numberOfTraveler: {
          ADT: 1,
          B15: 1,
          CHD: 0,
          INF: 0,
        },
      },
      cartEligibilities: {
        isTravelerSupportsEligible: true,
      },
      travelerSupports: {
        'SKH-XX-EXT2': {
          isSupportRegistered: true,
          blind: {
            isRequested: false,
          },
          deaf: {
            isRequested: false,
          },
        },
      },
      frequentFlyerCards: {
        'SKH-XX-EXT': {
          fqtv: {
            companyCode: 'NH',
            cardNumber: '9900000012',
          },
        },
      },
    },
    cartId: 'AAABBBCC11112222',
    creationDate: '2023-04-01T10:00:00',
    searchCriteria: {
      searchAirOffer: {
        itineraries: [
          {
            originLocationCode: 'NRT',
            destinationLocationCode: 'SFO',
            departureDate: '2100-01-03',
            departureTimeWindowFrom: '10:00:00',
            departureTimeWindowTo: '12:00:00',
            connection: {
              locationCode: 'LAX',
              time: 60,
            },
          },
          {
            originLocationCode: 'SFO',
            destinationLocationCode: 'NRT',
            departureDate: '2100-01-05',
            departureTimeWindowFrom: '10:00:00',
            departureTimeWindowTo: '12:00:00',
          },
        ],
        fare: {
          isMixedCabin: true,
          mixedCabinClasses: {
            departureCabinClass: 'first',
            returnCabinClass: 'business',
          },
        },
        promotion: {
          code: '15ABF2C1FJ',
        },
      },
    },
  },
  requestIds: [],
};

export const PlanReviewTestInvalidCart: CreateCartResponse = {
  warnings: [],
  data: {
    plan: {},
    previousPlan: {
      prices: {
        unitPrices: {
          'SKH-XX-EXT': {
            ticketPrices: {
              total: 111.11,
              base: 111.11,
              currencyCode: 'USD',
              airTransportationCharges: 111.11,
              thirdPartyCharges: 111.11,
              totalTaxes: 111.11,
              totalFlightSurcharges: 111.11,
              discount: {
                originalTotal: 123.12,
              },
              taxes: [
                {
                  code: 'ABC',
                  value: 111.11,
                  currencyCode: 'USD',
                },
                {
                  code: 'XXX',
                  value: 111.11,
                  currencyCode: 'USD',
                },
              ],
              fuelSurcharge: {
                value: 111.11,
                currencyCode: 'USD',
              },
              insuranceSurcharge: {
                value: 111.11,
                currencyCode: 'USD',
              },
              flightSurcharge: {
                value: 111.11,
                currencyCode: 'USD',
              },
              ticketingFee: {
                value: 111.11,
                currencyCode: 'USD',
              },
            },
            servicePrices: {
              lounge: {
                value: 111.11,
                currencyCode: 'USD',
              },
              firstBaggage: {
                value: 111.11,
                currencyCode: 'USD',
              },
              meal: {
                value: 111.11,
                currencyCode: 'USD',
              },
            },
            serviceTaxes: [
              {
                code: 'SS',
                value: 111.11,
                currencyCode: 'USD',
              },
              {
                code: '01',
                value: 111.11,
                currencyCode: 'USD',
              },
            ],
          },
        },
        totalPrices: {
          ticketPrices: {
            base: {
              value: 111.11,
              currencyCode: 'USD',
            },
            totalTaxes: {
              code: '00',
              value: 111.11,
              currencyCode: 'USD',
            },
            airTransportationCharges: {
              value: 111.11,
              currencyCode: 'USD',
            },
            thirdPartyCharges: {
              value: 111.11,
              currencyCode: 'USD',
            },
            totalFlightSurcharges: 111.11,
          },
          servicePrices: {
            total: {
              value: 111.11,
              currencyCode: 'USD',
            },
            totalTaxes: {
              code: '00',
              value: 111.11,
              currencyCode: 'USD',
            },
          },
          total: {
            value: 111.11,
            currencyCode: 'USD',
          },
          discount: {
            originalTotal: 123.12,
            aamDiscountCode: 'AAM TEST',
            cat25DiscountName: '',
          },
        },
      },
      airOfferIds: [
        {
          cartAirOfferId: 'OFF-1-OFF',
          offerNdcId: 'SR1V-XXXXXXXX-X',
        },
      ],
      airOffer: {
        bounds: [
          {
            airBoundId: 'BND-1',
            originLocationCode: 'HND',
            destinationLocationCode: 'LAX',
            originLocationName: 'TOKYO INTL HANEDA',
            originDepartureDateTime: '2023-12-01T10:00:00',
            originDepartureEstimatedDateTime: '2023-12-01T10:00:00',
            destinationLocationName: 'LOS ANGELES INTL',
            destinationArrivalDateTime: '2024-01-01T10:00:00',
            destinationArrivalEstimatedDateTime: '2024-01-01T10:00:00',
            destinationArrivalDaysDifference: 1,
            destinationArrivalEstimatedDaysDifference: 2,
            flights: [
              {
                id: 'EAI-X-OFF',
                cabin: 'business',
                bookingClass: 'B',
                departureDaysDifferenceByBound: 1,
                arrivalDaysDifferenceByFlight: 1,
                connectionTime: 36000,
                isMultiAirportConnection: false,
                marketingAirlineCode: 'NH',
                marketingFlightNumber: '123',
                operatingAirlineCode: 'NH',
                operatingAirlineName: 'ALL NIPPON AIRWAYS',
                departure: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2023-12-31T23:59:59',
                  country2letterCode: 'JP',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-01T22:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                arrival: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'HK',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                aircraftCode: '777',
                aircraftName: 'BOEING 777-200/300',
                duration: 6000,
                isLateNightDeparture: false,
                isOpenSegment: false,
                isSubjectToGovernmentApproval: true,
                stops: [
                  {
                    locationCode: 'HNL',
                    locationName: 'DANIEL K INOUYE INTL',
                  },
                  {
                    locationCode: 'CDG',
                    locationName: 'Charles de Gaule',
                  },
                ],
                aircraftConfigurationVersion: 'DUM',
                flightServices: {
                  isLoungeAvailable: true,
                },
                isStarAllianceOperated: true,
                isNhGroupMarketing: true,
                isNhGroupOperated: true,
                fareInfos: {
                  priorityCode: 9900,
                  fareClass: 'GXRFU1',
                },
                upgradableCabins: ['ecoPremium', 'business'],
                isJapanDomesticFlight: true,
                estimatedArrivalDaysDifferenceByFlight: -1,
              },
              {
                id: 'EAI-X-OFF2',
                cabin: 'eco',
                departureDaysDifferenceByBound: 1,
                arrivalDaysDifferenceByFlight: 1,
                connectionTime: 36000,
                isMultiAirportConnection: false,
                marketingAirlineCode: 'NH',
                marketingFlightNumber: '123',
                operatingAirlineCode: 'AF',
                operatingAirlineName: 'Air France',
                departure: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'JP',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                arrival: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'HK',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                aircraftCode: '777',
                aircraftName: 'BOEING 777-200/300',
                duration: 6000,
                isLateNightDeparture: false,
                isOpenSegment: false,
                isSubjectToGovernmentApproval: false,
                stops: [
                  {
                    locationCode: 'HNL',
                    locationName: 'DANIEL K INOUYE INTL',
                  },
                ],
                aircraftConfigurationVersion: 'DUM',
                flightServices: {
                  isLoungeAvailable: true,
                },
                isStarAllianceOperated: true,
                isNhGroupMarketing: true,
                isNhGroupOperated: false,
                fareInfos: {
                  priorityCode: 9500,
                  fareClass: 'GXRFU1',
                },
                upgradableCabins: ['ecoPremium', 'business'],
                isJapanDomesticFlight: false,
                estimatedArrivalDaysDifferenceByFlight: 1,
              },
            ],
            duration: 6000,
            isOtherMethodsConnection: true,
            isContainedDelayedFlight: false,
            isContainedEarlyDepartureFlight: false,
            numberOfConnections: 1,
            operatingAirlines: [
              {
                airlineCode: 'NH',
                airlineName: 'ALL NIPPON AIRWAYS',
              },
            ],
            isAllStarAllianceOperated: true,
            isAllNhGroupOperated: true,
            isContainedSubjectToGovernmentApproval: true,
            isContainedWaitlisted: true,
          },
          {
            airBoundId: 'BND-2',
            originLocationCode: 'HND',
            destinationLocationCode: 'LAX',
            originLocationName: 'TOKYO INTL HANEDA',
            originDepartureDateTime: '2023-12-01T10:00:00',
            originDepartureEstimatedDateTime: '2023-12-01T10:00:00',
            destinationLocationName: 'LOS ANGELES INTL',
            destinationArrivalDateTime: '2024-01-01T10:00:00',
            destinationArrivalEstimatedDateTime: '2024-01-01T10:00:00',
            destinationArrivalDaysDifference: 1,
            destinationArrivalEstimatedDaysDifference: 2,
            flights: [
              {
                id: 'EAI-X-OFF',
                cabin: 'eco',
                departureDaysDifferenceByBound: 1,
                arrivalDaysDifferenceByFlight: 1,
                connectionTime: 36000,
                isMultiAirportConnection: false,
                marketingAirlineCode: 'NH',
                marketingFlightNumber: '123',
                operatingAirlineCode: 'NH',
                operatingAirlineName: 'ALL NIPPON AIRWAYS',
                departure: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'JP',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                arrival: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'HK',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                aircraftCode: '777',
                aircraftName: 'BOEING 777-200/300',
                duration: 6000,
                isLateNightDeparture: false,
                isOpenSegment: false,
                isSubjectToGovernmentApproval: false,
                stops: [
                  {
                    locationCode: 'HNL',
                    locationName: 'DANIEL K INOUYE INTL',
                  },
                ],
                aircraftConfigurationVersion: 'DUM',
                flightServices: {
                  isLoungeAvailable: true,
                },
                isStarAllianceOperated: true,
                isNhGroupMarketing: true,
                isNhGroupOperated: false,
                fareInfos: {
                  priorityCode: 9200,
                  fareClass: 'GXRFU1',
                },
                upgradableCabins: ['ecoPremium', 'business'],
                isJapanDomesticFlight: false,
                estimatedArrivalDaysDifferenceByFlight: 1,
              },
            ],
            duration: 6000,
            isOtherMethodsConnection: false,
            isContainedDelayedFlight: false,
            isContainedEarlyDepartureFlight: false,
            numberOfConnections: 1,
            operatingAirlines: [
              {
                airlineCode: 'NH',
                airlineName: 'ALL NIPPON AIRWAYS',
              },
            ],
            isAllStarAllianceOperated: true,
            isAllNhGroupOperated: true,
            isContainedSubjectToGovernmentApproval: true,
            isContainedWaitlisted: true,
          },
        ],
        accrualMiles: 111,
        fareFamilyWithService: {
          priorityCode: 11,
        },
        existsTravelSkyHostedAirline: true,
        tripType: 'international',
      },
      services: {
        baggage: {
          firstBaggage: {
            'BND-1': {
              isAvailable: true,
              'SKH-XX-EXT': {
                serviceStatus: 'requested',
                isAvailable: true,
                prices: {
                  total: 10000,
                  currencyCode: 'JPY',
                },
                catalogue: {
                  prices: {
                    total: 11000,
                    currencyCode: 'JPY',
                  },
                },
              },
            },
          },
        },
        lounge: {
          'EAI-X-OFF': {
            isAvailable: true,
            'SKH-XX-EXT': {
              code: 'LOUG',
              statusCode: 'HK',
              serviceStatus: 'requested',
              isWaived: false,
              isAvailable: false,
              prices: {
                total: 20000,
                currencyCode: 'JPY',
              },
              catalogue: [
                {
                  code: 'MYLG',
                  quota: '3',
                  prices: {
                    total: 3000,
                    currencyCode: 'JPY',
                  },
                },
              ],
            },
          },
          'EAI-X-OFF2': {
            isAvailable: true,
            'SKH-XX-EXT': {
              code: '',
              statusCode: 'HK',
              serviceStatus: 'requested',
              isWaived: true,
              isAvailable: true,
              prices: {
                total: 20000,
                currencyCode: 'JPY',
              },
              catalogue: [
                {
                  code: 'MYLG',
                  quota: '3',
                  prices: {
                    total: 3000,
                    currencyCode: 'JPY',
                  },
                },
              ],
            },
          },
        },
        meal: {
          'EAI-X-OFF': {
            isAvailable: true,
            isExpired: false,
            'SKH-XX-EXT': {
              appliedMealList: [
                {
                  code: 'CAML',
                  id: 'XXXXXX',
                  type: 'ancillary',
                  preOrderMealMessageId: 'XXXXXXXXXX',
                  serviceStatus: 'requested',
                  price: {
                    total: 2501,
                    currencyCode: 'JPY',
                  },
                },
              ],
            },
            'SKH-XX-EXT2': {
              appliedMealList: [],
            },
          },
          'EAI-X-OFF2': {
            isAvailable: true,
            isExpired: true,
            'SKH-XX-EXT': {
              appliedMealList: [],
            },
          },
        },
        pet: {
          registeredPets: {
            'EAI-X-OFF': {
              'SKH-XX-EXT': [
                {
                  index: 1,
                  id: 'XXXX',
                  serviceStatus: 'requested',
                  cage: {
                    petType: '1CAT',
                    cageType: CartsUpdatePetRakunoriRequestServicesPetDetailInnerCage.CageTypeEnum.CarryOn,
                    weight: 0,
                  },
                },
              ],
              'SKH-XX-EXT2': [],
            },
            'EAI-X-OFF2': {},
          },
          hasCatalogue: true,
        },
      },
      chargeableAncillarySummary: {
        'BND-1': {
          firstBaggage: {
            numberOfRequests: 1,
          },
          lounge: {
            numberOfRequests: 1,
          },
          meal: {
            numberOfRequests: 1,
          },
        },
      },
      contacts: {
        representative: {
          emails: [
            {
              address: 'XXX_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'XXX*********************',
            },
          ],
          phones: [
            {
              type: 'M',
              countryPhoneExtension: '81',
              number: '312345678',
              encryptedNumber: '******678',
            },
          ],
          contactsDuringStay: [
            {
              id: 'AP-XX-PNR',
              number: 'XXXX HOTEL',
            },
          ],
        } as ContactsRepresentative,
        upgradeNotification: {
          emails: [
            {
              id: 'OT18',
              address: 'XXX_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'XXX*********************',
            },
          ],
        },
        'SKH-XX-EXT': {
          emails: [
            {
              address: 'AAA_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'AAA*********************',
              isSameAsRepresentative: true,
            },
          ],
          phones: [
            {
              countryPhoneExtension: '81',
              number: '987654321',
              encryptedNumber: '*****321',
              isSameAsRepresentative: false,
            },
          ],
          departureArrivalNotifications: [
            {
              emails: [
                {
                  address: 'BBB_XXXXXX@ANASYSTEMS.CO.JP',
                  recipient: 'XXXXXXXX',
                  lang: 'JA',
                },
              ],
              isRegisteredEmail: true,
            },
          ],
        },
        'SKH-XX-EXT2': {
          emails: [
            {
              address: 'AAA_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'AAA*********************',
              isSameAsRepresentative: true,
            },
          ],
          phones: [
            {
              countryPhoneExtension: '81',
              number: '987654321',
              encryptedNumber: '*****321',
              isSameAsRepresentative: true,
            },
          ],
          departureArrivalNotifications: [
            {
              emails: [
                {
                  address: 'BBB_XXXXXX@ANASYSTEMS.CO.JP',
                  recipient: 'XXXXXXXX',
                  lang: 'JA',
                },
              ],
              isRegisteredEmail: false,
            },
          ],
        },
      },
      travelers: [
        {
          id: 'SKH-XX-EXT',
          names: [
            {
              title: 'MR',
              firstName: 'E',
              middleName: 'B',
              lastName: 'SORAYAMA',
            },
          ],
          passengerTypeCode: 'ADT',
          accompanyingTravelerId: 'SKH-XX-EXT',
          dateOfBirth: '1999/01/01',
          encryptedDateOfBirth: '****/**/**',
          gender: 'male',
          regulatoryDetails: {
            passports: [
              {
                number: 'XXXXXXXXXXXXX',
              },
            ],
            isPassportRegistered: true,
          },
        },
        {
          id: 'SKH-XX-EXT2',
          names: [
            {
              title: 'MR',
              firstName: '',
              middleName: '',
              lastName: '',
            },
          ],
          passengerTypeCode: 'B15',
          accompanyingTravelerId: 'SKH-XX-EXT',
          dateOfBirth: '1999/01/01',
          gender: 'male',
          regulatoryDetails: {
            passports: [
              {
                number: 'XXXXXXXXXXXXX',
              },
            ],
          },
        },
      ],
      travelersSummary: {
        isRegistered: true,
        numberOfTraveler: {
          ADT: 1,
          B15: 1,
          CHD: 0,
          INF: 0,
        },
      },
      cartEligibilities: {
        isTravelerSupportsEligible: true,
      },
      travelerSupports: {
        'SKH-XX-EXT2': {
          isSupportRegistered: true,
          blind: {
            isRequested: false,
          },
          deaf: {
            isRequested: false,
          },
        },
      },
      frequentFlyerCards: {
        'SKH-XX-EXT': {
          fqtv: {
            companyCode: 'NH',
            cardNumber: '9900000012',
          },
        },
      },
    },
    cartId: 'AAABBBCC11112222',
    creationDate: '2023-04-01T10:00:00',
    searchCriteria: {
      searchAirOffer: {
        itineraries: [
          {
            originLocationCode: 'NRT',
            destinationLocationCode: 'SFO',
            departureDate: '2100-01-03',
            departureTimeWindowFrom: '10:00:00',
            departureTimeWindowTo: '12:00:00',
            connection: {
              locationCode: 'LAX',
              time: 60,
            },
          },
          {
            originLocationCode: 'SFO',
            destinationLocationCode: 'NRT',
            departureDate: '2100-01-05',
            departureTimeWindowFrom: '10:00:00',
            departureTimeWindowTo: '12:00:00',
          },
        ],
        fare: {
          isMixedCabin: true,
          mixedCabinClasses: {
            departureCabinClass: 'first',
            returnCabinClass: 'business',
          },
        },
        promotion: {
          code: '15ABF2C1FJ',
        },
      },
    },
  },
};

export const PlanReviewTestValidCart: CreateCartResponse = {
  warnings: [],
  data: {
    plan: {
      prices: {
        unitPrices: {
          'SKH-XX-EXT': {
            ticketPrices: {
              total: 111.11,
              base: 111.12,
              currencyCode: 'USD',
              airTransportationCharges: 111.13,
              thirdPartyCharges: 111.14,
              totalTaxes: 111.15,
              totalFlightSurcharges: 111.16,
              discount: {
                originalTotal: 123.12,
              },
              taxes: [
                {
                  code: 'ABC',
                  value: 111.17,
                  currencyCode: 'USD',
                },
                {
                  code: 'XXX',
                  value: 111.18,
                  currencyCode: 'USD',
                },
              ],
              fuelSurcharge: {
                value: 111.19,
                currencyCode: 'USD',
              },
              insuranceSurcharge: {
                value: 111.2,
                currencyCode: 'USD',
              },
              flightSurcharge: {
                value: 111.21,
                currencyCode: 'USD',
              },
              ticketingFee: {
                value: 111.22,
                currencyCode: 'USD',
              },
            },
            servicePrices: {
              lounge: {
                value: 111.23,
                currencyCode: 'USD',
              },
              firstBaggage: {
                value: 111.24,
                currencyCode: 'USD',
              },
              meal: {
                value: 111.25,
                currencyCode: 'USD',
              },
            },
            serviceTaxes: [
              {
                code: 'SS',
                value: 111.26,
                currencyCode: 'USD',
              },
              {
                code: '01',
                value: 111.27,
                currencyCode: 'USD',
              },
            ],
          },
        },
        totalPrices: {
          ticketPrices: {
            base: {
              value: 111.28,
              currencyCode: 'USD',
            },
            totalTaxes: {
              code: '00',
              value: 111.29,
              currencyCode: 'USD',
            },
            airTransportationCharges: {
              value: 111.3,
              currencyCode: 'USD',
            },
            thirdPartyCharges: {
              value: 111.31,
              currencyCode: 'USD',
            },
            totalFlightSurcharges: 111.32,
          },
          servicePrices: {
            total: {
              value: 111.33,
              currencyCode: 'USD',
            },
            totalTaxes: {
              code: '00',
              value: 111.34,
              currencyCode: 'USD',
            },
          },
          total: {
            value: 111.35,
            currencyCode: 'USD',
          },
          discount: {
            originalTotal: 123.12,
            aamDiscountCode: 'AAM TEST',
            cat25DiscountName: '',
          },
        },
      },
      airOfferIds: [
        {
          cartAirOfferId: 'OFF-1-OFF',
          offerNdcId: 'SR1V-XXXXXXXX-X',
        },
      ],
      airOffer: {
        bounds: [
          {
            airBoundId: 'BND-1',
            originLocationCode: 'HND',
            destinationLocationCode: 'LAX',
            originLocationName: 'TOKYO INTL HANEDA',
            originDepartureDateTime: '2023-12-01T10:00:00',
            originDepartureEstimatedDateTime: '2023-12-01T10:00:00',
            destinationLocationName: 'LOS ANGELES INTL',
            destinationArrivalDateTime: '2024-01-01T10:00:00',
            destinationArrivalEstimatedDateTime: '2024-01-01T10:00:00',
            destinationArrivalDaysDifference: 1,
            destinationArrivalEstimatedDaysDifference: 2,
            flights: [
              {
                id: 'EAI-X-OFF',
                cabin: 'first',
                bookingClass: 'B',
                departureDaysDifferenceByBound: 1,
                arrivalDaysDifferenceByFlight: 1,
                connectionTime: 36000,
                isMultiAirportConnection: false,
                marketingAirlineCode: 'NH',
                marketingFlightNumber: '123',
                operatingAirlineCode: 'NH',
                operatingAirlineName: 'ALL NIPPON AIRWAYS',
                departure: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2023-12-31T23:59:59',
                  country2letterCode: 'JP',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-01T22:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                arrival: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'HK',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'CDG',
                  iataAreaCode: 'TC3',
                },
                aircraftCode: '777',
                aircraftName: 'BOEING 777-200/300',
                duration: 6000,
                isLateNightDeparture: false,
                isOpenSegment: false,
                isSubjectToGovernmentApproval: true,
                stops: [
                  {
                    locationCode: 'HNL',
                    locationName: 'DANIEL K INOUYE INTL',
                  },
                  {
                    locationCode: 'CDG',
                    locationName: 'Charles de Gaule',
                  },
                ],
                aircraftConfigurationVersion: 'DUM',
                flightServices: {
                  isLoungeAvailable: true,
                  wiFiType: '0',
                },
                meal: {
                  mealCode: 'M',
                },
                isStarAllianceOperated: true,
                isNhGroupMarketing: true,
                isNhGroupOperated: true,
                fareInfos: {
                  priorityCode: 9900,
                  fareClass: 'GXRFU1',
                  fareType: 'other',
                },
                upgradableCabins: ['business', 'first'],
                isJapanDomesticFlight: true,
                estimatedArrivalDaysDifferenceByFlight: -1,
              },
              {
                id: 'EAI-X-OFF2',
                cabin: 'eco',
                departureDaysDifferenceByBound: 1,
                arrivalDaysDifferenceByFlight: 1,
                connectionTime: 36000,
                isMultiAirportConnection: false,
                marketingAirlineCode: 'NH',
                marketingFlightNumber: '123',
                operatingAirlineCode: 'AF',
                operatingAirlineName: 'Air France',
                departure: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'JP',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'ORY',
                  iataAreaCode: 'TC3',
                },
                arrival: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'HK',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'WAW',
                  iataAreaCode: 'TC3',
                },
                aircraftCode: '777',
                aircraftName: 'BOEING 777-200/300',
                duration: 6000,
                isLateNightDeparture: false,
                isOpenSegment: false,
                isSubjectToGovernmentApproval: false,
                stops: [
                  {
                    locationCode: 'HNL',
                    locationName: 'DANIEL K INOUYE INTL',
                  },
                ],
                aircraftConfigurationVersion: 'DUM',
                flightServices: {
                  isLoungeAvailable: true,
                },
                isStarAllianceOperated: true,
                isNhGroupMarketing: true,
                isNhGroupOperated: false,
                fareInfos: {
                  priorityCode: 9500,
                  fareClass: 'GXRFU1',
                },
                upgradableCabins: ['ecoPremium', 'business'],
                isJapanDomesticFlight: false,
                estimatedArrivalDaysDifferenceByFlight: 1,
              },
            ],
            duration: 6000,
            isOtherMethodsConnection: true,
            isContainedDelayedFlight: false,
            isContainedEarlyDepartureFlight: false,
            numberOfConnections: 1,
            operatingAirlines: [
              {
                airlineCode: 'NH',
                airlineName: 'ALL NIPPON AIRWAYS',
              },
            ],
            isAllStarAllianceOperated: true,
            isAllNhGroupOperated: true,
            isContainedSubjectToGovernmentApproval: true,
            isContainedWaitlisted: true,
          },
          {
            airBoundId: 'BND-2',
            originLocationCode: 'HND',
            destinationLocationCode: 'LAX',
            originLocationName: 'TOKYO INTL HANEDA',
            originDepartureDateTime: '2023-12-01T10:00:00',
            originDepartureEstimatedDateTime: '2023-12-01T10:00:00',
            destinationLocationName: 'LOS ANGELES INTL',
            destinationArrivalDateTime: '2024-01-01T10:00:00',
            destinationArrivalEstimatedDateTime: '2024-01-01T10:00:00',
            destinationArrivalDaysDifference: 1,
            destinationArrivalEstimatedDaysDifference: 2,
            flights: [
              {
                id: 'EAI-X-OFF',
                cabin: 'eco',
                departureDaysDifferenceByBound: 1,
                arrivalDaysDifferenceByFlight: 1,
                connectionTime: 36000,
                isMultiAirportConnection: false,
                marketingAirlineCode: 'NH',
                marketingFlightNumber: '123',
                operatingAirlineCode: 'NH',
                operatingAirlineName: 'ALL NIPPON AIRWAYS',
                departure: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'JP',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                arrival: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'HK',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                aircraftCode: '777',
                aircraftName: 'BOEING 777-200/300',
                duration: 6000,
                isLateNightDeparture: false,
                isOpenSegment: false,
                isSubjectToGovernmentApproval: false,
                stops: [
                  {
                    locationCode: 'HNL',
                    locationName: 'DANIEL K INOUYE INTL',
                  },
                ],
                aircraftConfigurationVersion: 'DUM',
                flightServices: {
                  isLoungeAvailable: true,
                },
                isStarAllianceOperated: true,
                isNhGroupMarketing: true,
                isNhGroupOperated: false,
                fareInfos: {
                  priorityCode: 9200,
                  fareClass: 'GXRFU1',
                },
                upgradableCabins: ['ecoPremium', 'business'],
                isJapanDomesticFlight: false,
                estimatedArrivalDaysDifferenceByFlight: 1,
              },
            ],
            duration: 6000,
            isOtherMethodsConnection: false,
            isContainedDelayedFlight: false,
            isContainedEarlyDepartureFlight: false,
            numberOfConnections: 1,
            operatingAirlines: [
              {
                airlineCode: 'NH',
                airlineName: 'ALL NIPPON AIRWAYS',
              },
            ],
            isAllStarAllianceOperated: true,
            isAllNhGroupOperated: true,
            isContainedSubjectToGovernmentApproval: true,
            isContainedWaitlisted: true,
          },
        ],
        accrualMiles: 111,
        fareFamilyWithService: {
          priorityCode: 11,
        },
        existsTravelSkyHostedAirline: true,
        tripType: 'domestic',
        statusType: 'other',
      },
      services: {
        baggage: {
          firstBaggage: {
            'BND-1': {
              isAvailable: true,
              'SKH-XX-EXT': {
                serviceStatus: 'requested',
                isAvailable: true,
                prices: {
                  total: 10000,
                  currencyCode: 'JPY',
                },
                catalogue: {
                  prices: {
                    total: 11000,
                    currencyCode: 'JPY',
                  },
                },
              },
            },
            'BND-2': {
              isAvailable: true,
              'SKH-XX-EXT': {
                serviceStatus: 'requested',
                isAvailable: true,
                prices: {
                  total: 10000,
                  currencyCode: 'JPY',
                },
                catalogue: {
                  prices: {
                    total: 11000,
                    currencyCode: 'JPY',
                  },
                },
              },
            },
            'BND-3': {
              isAvailable: true,
              'SKH-XX-EXT': {
                serviceStatus: 'requested',
                isAvailable: true,
                prices: {
                  total: 10000,
                  currencyCode: 'JPY',
                },
                catalogue: {
                  prices: {
                    total: 11000,
                    currencyCode: 'JPY',
                  },
                },
              },
            },
            'BND-4': {
              isAvailable: true,
              'SKH-XX-EXT': {
                serviceStatus: 'requested',
                isAvailable: true,
                prices: {
                  total: 10000,
                  currencyCode: 'JPY',
                },
                catalogue: {
                  prices: {
                    total: 11000,
                    currencyCode: 'JPY',
                  },
                },
              },
            },
            'BND-5': {
              isAvailable: true,
              'SKH-XX-EXT': {
                serviceStatus: 'requested',
                isAvailable: true,
                prices: {
                  total: 10000,
                  currencyCode: 'JPY',
                },
                catalogue: {
                  prices: {
                    total: 11000,
                    currencyCode: 'JPY',
                  },
                },
              },
            },
          },
        },
        lounge: {
          'EAI-X-OFF': {
            isAvailable: true,
            'SKH-XX-EXT': {
              code: 'LOUG',
              statusCode: 'HK',
              serviceStatus: 'requested',
              isWaived: false,
              isAvailable: false,
              prices: {
                total: 20000,
                currencyCode: 'JPY',
              },
              catalogue: [
                {
                  code: 'MYLG',
                  quota: '3',
                  prices: {
                    total: 3000,
                    currencyCode: 'JPY',
                  },
                },
              ],
            },
          },
          'EAI-X-OFF2': {
            isAvailable: true,
            'SKH-XX-EXT': {
              code: '',
              statusCode: 'HK',
              serviceStatus: 'requested',
              isWaived: true,
              isAvailable: true,
              prices: {
                total: 20000,
                currencyCode: 'JPY',
              },
              catalogue: [
                {
                  code: 'MYLG',
                  quota: '3',
                  prices: {
                    total: 3000,
                    currencyCode: 'JPY',
                  },
                },
              ],
            },
          },
          'EAI-X-OFF3': {
            isAvailable: true,
            'SKH-XX-EXT': {
              code: '',
              statusCode: 'HK',
              serviceStatus: 'requested',
              isWaived: true,
              isAvailable: true,
              prices: {
                total: 20000,
                currencyCode: 'JPY',
              },
              catalogue: [
                {
                  code: 'MYLG',
                  quota: '3',
                  prices: {
                    total: 3000,
                    currencyCode: 'JPY',
                  },
                },
              ],
            },
          },
          'EAI-X-OFF4': {
            isAvailable: true,
            'SKH-XX-EXT': {
              code: '',
              statusCode: 'HK',
              serviceStatus: 'requested',
              isWaived: true,
              isAvailable: true,
              prices: {
                total: 20000,
                currencyCode: 'JPY',
              },
              catalogue: [
                {
                  code: 'MYLG',
                  quota: '3',
                  prices: {
                    total: 3000,
                    currencyCode: 'JPY',
                  },
                },
              ],
            },
          },
          'EAI-X-OFF5': {
            isAvailable: true,
            'SKH-XX-EXT': {
              code: '',
              statusCode: 'HK',
              serviceStatus: 'requested',
              isWaived: true,
              isAvailable: true,
              prices: {
                total: 20000,
                currencyCode: 'JPY',
              },
              catalogue: [
                {
                  code: 'MYLG',
                  quota: '3',
                  prices: {
                    total: 3000,
                    currencyCode: 'JPY',
                  },
                },
              ],
            },
          },
        },
        meal: {
          'EAI-X-OFF': {
            isAvailable: true,
            isExpired: false,
            'SKH-XX-EXT': {
              appliedMealList: [
                {
                  code: 'CAML',
                  id: 'XXXXXX',
                  type: 'ancillary',
                  preOrderMealMessageId: 'XXXXXXXXXX',
                  serviceStatus: 'requested',
                  price: {
                    total: 2501,
                    currencyCode: 'JPY',
                  },
                },
              ],
            },
            'SKH-XX-EXT2': {
              appliedMealList: [],
            },
          },
          'EAI-X-OFF2': {
            isAvailable: true,
            isExpired: true,
            'SKH-XX-EXT': {
              appliedMealList: [],
            },
          },
          'EAI-X-OFF3': {
            isAvailable: true,
            isExpired: true,
            'SKH-XX-EXT': {
              appliedMealList: [],
            },
          },
          'EAI-X-OFF4': {
            isAvailable: true,
            isExpired: true,
            'SKH-XX-EXT': {
              appliedMealList: [],
            },
          },
          'EAI-X-OFF5': {
            isAvailable: true,
            isExpired: true,
            'SKH-XX-EXT': {
              appliedMealList: [],
            },
          },
        },
        pet: {
          registeredPets: {
            'EAI-X-OFF': {
              'SKH-XX-EXT': [
                {
                  index: 1,
                  id: 'XXXX',
                  serviceStatus: 'requested',
                  cage: {
                    petType: '1CAT',
                    cageType: CartsUpdatePetRakunoriRequestServicesPetDetailInnerCage.CageTypeEnum.CarryOn,
                    weight: 0,
                  },
                },
              ],
              'SKH-XX-EXT2': [],
            },
            'EAI-X-OFF2': {},
          },
          hasCatalogue: true,
        },
      },
      chargeableAncillarySummary: {
        'BND-1': {
          firstBaggage: {
            numberOfRequests: 1,
          },
          lounge: {
            numberOfRequests: 1,
          },
          meal: {
            numberOfRequests: 1,
          },
        },
      },
      contacts: {
        representative: {
          emails: [
            {
              address: 'XXX_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'XXX*********************',
            },
          ],
          phones: [
            {
              type: 'M',
              countryPhoneExtension: '81',
              number: '312345678',
              encryptedNumber: '******678',
            },
          ],
          contactsDuringStay: [
            {
              id: 'AP-XX-PNR',
              number: 'XXXX HOTEL',
            },
          ],
        } as ContactsRepresentative,
        upgradeNotification: {
          emails: [
            {
              id: 'OT18',
              address: 'XXX_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'XXX*********************',
            },
          ],
        },
        'SKH-XX-EXT': {
          emails: [
            {
              address: 'AAA_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'AAA*********************',
              isSameAsRepresentative: true,
            },
          ],
          phones: [
            {
              countryPhoneExtension: '81',
              number: '987654321',
              encryptedNumber: '*****321',
              isSameAsRepresentative: false,
            },
          ],
          departureArrivalNotifications: [
            {
              emails: [
                {
                  address: 'BBB_XXXXXX@ANASYSTEMS.CO.JP',
                  recipient: 'XXXXXXXX',
                  lang: 'JA',
                },
              ],
              isRegisteredEmail: true,
            },
          ],
        },
        'SKH-XX-EXT2': {
          emails: [
            {
              address: 'AAA_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'AAA*********************',
              isSameAsRepresentative: true,
            },
          ],
          phones: [
            {
              countryPhoneExtension: '81',
              number: '987654321',
              encryptedNumber: '*****321',
              isSameAsRepresentative: true,
            },
          ],
          departureArrivalNotifications: [
            {
              emails: [
                {
                  address: 'BBB_XXXXXX@ANASYSTEMS.CO.JP',
                  recipient: 'XXXXXXXX',
                  lang: 'JA',
                },
              ],
              isRegisteredEmail: false,
            },
          ],
        },
      },
      travelers: [
        {
          id: 'SKH-XX-EXT',
          names: [
            {
              title: 'MR',
              firstName: 'E',
              middleName: 'B',
              lastName: 'SORAYAMA',
            },
          ],
          passengerTypeCode: 'ADT',
          accompanyingTravelerId: 'SKH-XX-EXT',
          dateOfBirth: '1999/01/01',
          encryptedDateOfBirth: '****/**/**',
          gender: 'male',
          regulatoryDetails: {
            passports: [
              {
                number: 'XXXXXXXXXXXXX',
              },
            ],
            isPassportRegistered: true,
          },
        },
        {
          id: 'SKH-XX-EXT2',
          names: [
            {
              title: 'MR',
              firstName: '',
              middleName: '',
              lastName: '',
            },
          ],
          passengerTypeCode: 'B15',
          accompanyingTravelerId: 'SKH-XX-EXT',
          dateOfBirth: '1999/01/01',
          gender: 'male',
          regulatoryDetails: {
            passports: [
              {
                number: 'XXXXXXXXXXXXX',
              },
            ],
          },
        },
      ],
      travelersSummary: {
        isRegistered: true,
        numberOfTraveler: {
          ADT: 1,
          B15: 1,
          CHD: 0,
          INF: 0,
        },
      },
      cartEligibilities: {
        isTravelerSupportsEligible: true,
      },
      travelerSupports: {
        'SKH-XX-EXT2': {
          isSupportRegistered: true,
          blind: {
            isRequested: false,
          },
          deaf: {
            isRequested: false,
          },
        },
      },
      frequentFlyerCards: {
        'SKH-XX-EXT': {
          fqtv: {
            companyCode: 'NH',
            cardNumber: '9900000012',
          },
        },
      },
    },
    previousPlan: {},
    cartId: 'TESTGETCART_VALID',
    creationDate: '2023-04-01T10:00:00',
    searchCriteria: {
      searchAirOffer: {
        itineraries: [
          {
            originLocationCode: 'NRT',
            destinationLocationCode: 'SFO',
            departureDate: '2100-01-03',
            departureTimeWindowFrom: '10:00:00',
            departureTimeWindowTo: '12:00:00',
            connection: {
              locationCode: 'LAX',
              time: 60,
            },
          },
          {
            originLocationCode: 'SFO',
            destinationLocationCode: 'NRT',
            departureDate: '2100-01-05',
            departureTimeWindowFrom: '10:00:00',
            departureTimeWindowTo: '12:00:00',
          },
        ],
        fare: {
          cabinClass: 'eco',
          isMixedCabin: true,
          mixedCabinClasses: {
            departureCabinClass: 'first',
            returnCabinClass: 'business',
          },
        },
        promotion: {
          code: '15ABF2C1FJ',
        },
      },
    },
  },
};

export const PlanReviewTestUpsellCart: CreateCartResponse = {
  warnings: [],
  data: {
    plan: {
      prices: {
        unitPrices: {
          'SKH-XX-EXT': {
            ticketPrices: {
              total: 111.11,
              base: 111.11,
              currencyCode: 'USD',
              airTransportationCharges: 111.11,
              thirdPartyCharges: 111.11,
              totalTaxes: 111.11,
              totalFlightSurcharges: 111.11,
              discount: {
                originalTotal: 123.12,
              },
              taxes: [
                {
                  code: 'ABC',
                  value: 111.11,
                  currencyCode: 'USD',
                },
                {
                  code: 'XXX',
                  value: 111.11,
                  currencyCode: 'USD',
                },
              ],
              fuelSurcharge: {
                value: 111.11,
                currencyCode: 'USD',
              },
              insuranceSurcharge: {
                value: 111.11,
                currencyCode: 'USD',
              },
              flightSurcharge: {
                value: 111.11,
                currencyCode: 'USD',
              },
              ticketingFee: {
                value: 111.11,
                currencyCode: 'USD',
              },
            },
            servicePrices: {
              lounge: {
                value: 111.11,
                currencyCode: 'USD',
              },
              firstBaggage: {
                value: 111.11,
                currencyCode: 'USD',
              },
              meal: {
                value: 111.11,
                currencyCode: 'USD',
              },
            },
            serviceTaxes: [
              {
                code: 'SS',
                value: 111.11,
                currencyCode: 'USD',
              },
              {
                code: '01',
                value: 111.11,
                currencyCode: 'USD',
              },
            ],
          },
        },
        totalPrices: {
          ticketPrices: {
            base: {
              value: 111.11,
              currencyCode: 'USD',
            },
            totalTaxes: {
              code: '00',
              value: 111.11,
              currencyCode: 'USD',
            },
            airTransportationCharges: {
              value: 111.11,
              currencyCode: 'USD',
            },
            thirdPartyCharges: {
              value: 111.11,
              currencyCode: 'USD',
            },
            totalFlightSurcharges: 111.11,
          },
          servicePrices: {
            total: {
              value: 111.11,
              currencyCode: 'USD',
            },
            totalTaxes: {
              code: '00',
              value: 111.11,
              currencyCode: 'USD',
            },
          },
          total: {
            value: 111.11,
            currencyCode: 'USD',
          },
          discount: {
            originalTotal: 123.12,
            aamDiscountCode: 'AAM TEST',
            cat25DiscountName: '',
          },
        },
      },
      airOfferIds: [
        {
          cartAirOfferId: 'OFF-1-OFF',
          offerNdcId: 'SR1V-XXXXXXXX-X',
        },
      ],
      airOffer: {
        bounds: [
          {
            airBoundId: 'BND-1',
            originLocationCode: 'HND',
            destinationLocationCode: 'SFX',
            originLocationName: 'TOKYO INTL HANEDA',
            originDepartureDateTime: '2023-12-01T10:00:00',
            originDepartureEstimatedDateTime: '2023-12-01T10:00:00',
            destinationLocationName: 'LOS ANGELES INTL',
            destinationArrivalDateTime: '2024-01-01T10:00:00',
            destinationArrivalEstimatedDateTime: '2024-01-01T10:00:00',
            destinationArrivalDaysDifference: 1,
            destinationArrivalEstimatedDaysDifference: 2,
            flights: [
              {
                id: 'EAI-X-OFF',
                cabin: 'eco',
                bookingClass: 'B',
                departureDaysDifferenceByBound: 1,
                arrivalDaysDifferenceByFlight: 1,
                connectionTime: 36000,
                isMultiAirportConnection: false,
                marketingAirlineCode: 'NH',
                marketingFlightNumber: '111',
                operatingAirlineCode: 'NH',
                operatingAirlineName: 'ALL NIPPON AIRWAYS',
                departure: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2023-12-31T23:59:59',
                  country2letterCode: 'JP',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-01T22:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                arrival: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'FR',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'CDG',
                  iataAreaCode: 'TC3',
                },
                aircraftCode: '777',
                aircraftName: 'BOEING 777-200/300',
                duration: 6000,
                isLateNightDeparture: false,
                isOpenSegment: false,
                isSubjectToGovernmentApproval: true,
                stops: [
                  {
                    locationCode: 'HNL',
                    locationName: 'DANIEL K INOUYE INTL',
                  },
                  {
                    locationCode: 'CDG',
                    locationName: 'Charles de Gaule',
                  },
                ],
                aircraftConfigurationVersion: 'DUM',
                flightServices: {
                  isLoungeAvailable: true,
                },
                isStarAllianceOperated: true,
                isNhGroupMarketing: true,
                isNhGroupOperated: true,
                fareInfos: {
                  fareClass: 'GXRFU1',
                },
                upgradableCabins: ['ecoPremium', 'business'],
                isJapanDomesticFlight: true,
                estimatedArrivalDaysDifferenceByFlight: -1,
              },
              {
                id: 'EAI-X-OFF2',
                cabin: 'eco',
                departureDaysDifferenceByBound: 1,
                arrivalDaysDifferenceByFlight: 1,
                connectionTime: 36000,
                isMultiAirportConnection: false,
                marketingAirlineCode: 'NH',
                marketingFlightNumber: '112',
                operatingAirlineCode: 'AF',
                operatingAirlineName: 'Air France',
                departure: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'FR',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'CDG',
                  iataAreaCode: 'TC3',
                },
                arrival: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'US',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'SFX',
                  iataAreaCode: 'TC3',
                },
                aircraftCode: '777',
                aircraftName: 'BOEING 777-200/300',
                duration: 6000,
                isLateNightDeparture: false,
                isOpenSegment: false,
                isSubjectToGovernmentApproval: false,
                stops: [
                  {
                    locationCode: 'HNL',
                    locationName: 'DANIEL K INOUYE INTL',
                  },
                ],
                aircraftConfigurationVersion: 'DUM',
                flightServices: {
                  isLoungeAvailable: true,
                },
                isStarAllianceOperated: true,
                isNhGroupMarketing: true,
                isNhGroupOperated: false,
                fareInfos: {
                  fareClass: 'GXRFU1',
                },
                upgradableCabins: ['ecoPremium', 'business'],
                isJapanDomesticFlight: false,
                estimatedArrivalDaysDifferenceByFlight: 1,
              },
            ],
            duration: 6000,
            isOtherMethodsConnection: true,
            isContainedDelayedFlight: false,
            isContainedEarlyDepartureFlight: false,
            numberOfConnections: 1,
            operatingAirlines: [
              {
                airlineCode: 'NH',
                airlineName: 'ALL NIPPON AIRWAYS',
              },
            ],
            isAllStarAllianceOperated: true,
            isAllNhGroupOperated: true,
            isContainedSubjectToGovernmentApproval: true,
            isContainedWaitlisted: true,
          },
          {
            airBoundId: 'BND-2',
            originLocationCode: 'SFX',
            destinationLocationCode: 'HND',
            originLocationName: 'TOKYO INTL HANEDA',
            originDepartureDateTime: '2023-12-01T10:00:00',
            originDepartureEstimatedDateTime: '2023-12-01T10:00:00',
            destinationLocationName: 'LOS ANGELES INTL',
            destinationArrivalDateTime: '2024-01-01T10:00:00',
            destinationArrivalEstimatedDateTime: '2024-01-01T10:00:00',
            destinationArrivalDaysDifference: 1,
            destinationArrivalEstimatedDaysDifference: 2,
            flights: [
              {
                id: 'EAI-X-OFF',
                cabin: 'eco',
                departureDaysDifferenceByBound: 1,
                arrivalDaysDifferenceByFlight: 1,
                connectionTime: 36000,
                isMultiAirportConnection: false,
                marketingAirlineCode: 'NH',
                marketingFlightNumber: '221',
                operatingAirlineCode: 'NH',
                operatingAirlineName: 'ALL NIPPON AIRWAYS',
                departure: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'US',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'SFX',
                  iataAreaCode: 'TC3',
                },
                arrival: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'FR',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'CDG',
                  iataAreaCode: 'TC3',
                },
                aircraftCode: '777',
                aircraftName: 'BOEING 777-200/300',
                duration: 6000,
                isLateNightDeparture: false,
                isOpenSegment: false,
                isSubjectToGovernmentApproval: false,
                stops: [
                  {
                    locationCode: 'HNL',
                    locationName: 'DANIEL K INOUYE INTL',
                  },
                ],
                aircraftConfigurationVersion: 'DUM',
                flightServices: {
                  isLoungeAvailable: true,
                },
                isStarAllianceOperated: true,
                isNhGroupMarketing: true,
                isNhGroupOperated: false,
                fareInfos: {
                  fareClass: 'GXRFU1',
                },
                upgradableCabins: ['ecoPremium', 'business'],
                isJapanDomesticFlight: false,
                estimatedArrivalDaysDifferenceByFlight: 1,
              },
              {
                id: 'EAI-X-OFF2',
                cabin: 'eco',
                departureDaysDifferenceByBound: 1,
                arrivalDaysDifferenceByFlight: 1,
                connectionTime: 36000,
                isMultiAirportConnection: false,
                marketingAirlineCode: 'NH',
                marketingFlightNumber: '222',
                operatingAirlineCode: 'NH',
                operatingAirlineName: 'ALL NIPPON AIRWAYS',
                departure: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'FR',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'CDG',
                  iataAreaCode: 'TC3',
                },
                arrival: {
                  gate: '20',
                  terminal: 'T1',
                  estimatedDateTime: '2024-01-01T23:59:59',
                  country2letterCode: 'JP',
                  locationName: 'TOKYO INTL HANEDA',
                  dateTime: '2023-12-31T23:59:59',
                  locationCode: 'HND',
                  iataAreaCode: 'TC3',
                },
                aircraftCode: '777',
                aircraftName: 'BOEING 777-200/300',
                duration: 6000,
                isLateNightDeparture: false,
                isOpenSegment: false,
                isSubjectToGovernmentApproval: false,
                stops: [
                  {
                    locationCode: 'HNL',
                    locationName: 'DANIEL K INOUYE INTL',
                  },
                ],
                aircraftConfigurationVersion: 'DUM',
                flightServices: {
                  isLoungeAvailable: true,
                },
                isStarAllianceOperated: true,
                isNhGroupMarketing: true,
                isNhGroupOperated: false,
                fareInfos: {
                  fareClass: 'GXRFU1',
                },
                upgradableCabins: ['ecoPremium', 'business'],
                isJapanDomesticFlight: false,
                estimatedArrivalDaysDifferenceByFlight: 1,
              },
            ],
            duration: 6000,
            isOtherMethodsConnection: false,
            isContainedDelayedFlight: false,
            isContainedEarlyDepartureFlight: false,
            numberOfConnections: 1,
            operatingAirlines: [
              {
                airlineCode: 'NH',
                airlineName: 'ALL NIPPON AIRWAYS',
              },
            ],
            isAllStarAllianceOperated: true,
            isAllNhGroupOperated: true,
            isContainedSubjectToGovernmentApproval: true,
            isContainedWaitlisted: true,
          },
        ],
        accrualMiles: 111,
        fareFamilyWithService: {
          priorityCode: 11,
        },
        existsTravelSkyHostedAirline: true,
        tripType: 'international',
        statusType: 'other',
      },
      services: {
        baggage: {
          firstBaggage: {
            'BND-1': {
              isAvailable: true,
              'SKH-XX-EXT': {
                serviceStatus: 'requested',
                isAvailable: true,
                prices: {
                  total: 10000,
                  currencyCode: 'JPY',
                },
                catalogue: {
                  prices: {
                    total: 11000,
                    currencyCode: 'JPY',
                  },
                },
              },
            },
          },
        },
        lounge: {
          'EAI-X-OFF': {
            isAvailable: true,
            'SKH-XX-EXT': {
              code: 'LOUG',
              statusCode: 'HK',
              serviceStatus: 'requested',
              isWaived: false,
              isAvailable: false,
              prices: {
                total: 20000,
                currencyCode: 'JPY',
              },
              catalogue: [
                {
                  code: 'MYLG',
                  quota: '3',
                  prices: {
                    total: 3000,
                    currencyCode: 'JPY',
                  },
                },
              ],
            },
          },
          'EAI-X-OFF2': {
            isAvailable: true,
            'SKH-XX-EXT': {
              code: '',
              statusCode: 'HK',
              serviceStatus: 'requested',
              isWaived: true,
              isAvailable: true,
              prices: {
                total: 20000,
                currencyCode: 'JPY',
              },
              catalogue: [
                {
                  code: 'MYLG',
                  quota: '3',
                  prices: {
                    total: 3000,
                    currencyCode: 'JPY',
                  },
                },
              ],
            },
          },
        },
        meal: {
          'EAI-X-OFF': {
            isAvailable: true,
            isExpired: false,
            'SKH-XX-EXT': {
              appliedMealList: [
                {
                  code: 'CAML',
                  id: 'XXXXXX',
                  type: 'ancillary',
                  preOrderMealMessageId: 'XXXXXXXXXX',
                  serviceStatus: 'requested',
                  price: {
                    total: 2501,
                    currencyCode: 'JPY',
                  },
                },
              ],
            },
            'SKH-XX-EXT2': {
              appliedMealList: [],
            },
          },
          'EAI-X-OFF2': {
            isAvailable: true,
            isExpired: true,
            'SKH-XX-EXT': {
              appliedMealList: [],
            },
          },
        },
      },
      chargeableAncillarySummary: {
        'BND-1': {
          firstBaggage: {
            numberOfRequests: 1,
          },
          lounge: {
            numberOfRequests: 1,
          },
          meal: {
            numberOfRequests: 1,
          },
        },
      },
      contacts: {
        representative: {
          emails: [
            {
              address: 'XXX_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'XXX*********************',
            },
          ],
          phones: [
            {
              type: 'M',
              countryPhoneExtension: '81',
              number: '312345678',
              encryptedNumber: '******678',
            },
          ],
          contactsDuringStay: [
            {
              id: 'AP-XX-PNR',
              number: 'XXXX HOTEL',
            },
          ],
        } as ContactsRepresentative,
        upgradeNotification: {
          emails: [
            {
              id: 'OT18',
              address: 'XXX_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'XXX*********************',
            },
          ],
        },
        'SKH-XX-EXT': {
          emails: [
            {
              address: 'AAA_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'AAA*********************',
              isSameAsRepresentative: true,
            },
          ],
          phones: [
            {
              countryPhoneExtension: '81',
              number: '987654321',
              encryptedNumber: '*****321',
              isSameAsRepresentative: false,
            },
          ],
          departureArrivalNotifications: [
            {
              emails: [
                {
                  address: 'BBB_XXXXXX@ANASYSTEMS.CO.JP',
                  recipient: 'XXXXXXXX',
                  lang: 'JA',
                },
              ],
              isRegisteredEmail: true,
            },
          ],
        },
        'SKH-XX-EXT2': {
          emails: [
            {
              address: 'AAA_XXXXXX@ANASYSTEMS.CO.JP',
              encryptedAddress: 'AAA*********************',
              isSameAsRepresentative: true,
            },
          ],
          phones: [
            {
              countryPhoneExtension: '81',
              number: '987654321',
              encryptedNumber: '*****321',
              isSameAsRepresentative: true,
            },
          ],
          departureArrivalNotifications: [
            {
              emails: [
                {
                  address: 'BBB_XXXXXX@ANASYSTEMS.CO.JP',
                  recipient: 'XXXXXXXX',
                  lang: 'JA',
                },
              ],
              isRegisteredEmail: false,
            },
          ],
        },
      },
      travelers: [
        {
          id: 'SKH-XX-EXT',
          names: [
            {
              title: 'MR',
              firstName: 'E',
              middleName: 'B',
              lastName: 'SORAYAMA',
            },
          ],
          passengerTypeCode: 'ADT',
          accompanyingTravelerId: 'SKH-XX-EXT',
          dateOfBirth: '1999/01/01',
          encryptedDateOfBirth: '****/**/**',
          gender: 'male',
          regulatoryDetails: {
            passports: [
              {
                number: 'XXXXXXXXXXXXX',
              },
            ],
            isPassportRegistered: true,
          },
        },
        {
          id: 'SKH-XX-EXT2',
          names: [
            {
              title: 'MR',
              firstName: '',
              middleName: '',
              lastName: '',
            },
          ],
          passengerTypeCode: 'B15',
          accompanyingTravelerId: 'SKH-XX-EXT',
          dateOfBirth: '1999/01/01',
          gender: 'male',
          regulatoryDetails: {
            passports: [
              {
                number: 'XXXXXXXXXXXXX',
              },
            ],
          },
        },
      ],
      travelersSummary: {
        isRegistered: true,
        numberOfTraveler: {
          ADT: 1,
          B15: 0,
          CHD: 1,
          INF: 0,
        },
      },
      cartEligibilities: {
        isTravelerSupportsEligible: true,
      },
      travelerSupports: {
        'SKH-XX-EXT2': {
          isSupportRegistered: true,
          blind: {
            isRequested: false,
          },
          deaf: {
            isRequested: false,
          },
        },
      },
      frequentFlyerCards: {
        'SKH-XX-EXT': {
          fqtv: {
            companyCode: 'NH',
            cardNumber: '9900000012',
          },
        },
      },
    },
    previousPlan: {},
    cartId: 'AAABBBCC11112222',
    creationDate: '2023-04-01T10:00:00',
    searchCriteria: {
      searchAirOffer: {
        itineraries: [
          {
            originLocationCode: 'NRT',
            destinationLocationCode: 'SFO',
            departureDate: '2100-01-03',
            departureTimeWindowFrom: '10:00:00',
            departureTimeWindowTo: '12:00:00',
            connection: {
              locationCode: 'LAX',
              time: 60,
            },
          },
          {
            originLocationCode: 'SFO',
            destinationLocationCode: 'NRT',
            departureDate: '2100-01-05',
            departureTimeWindowFrom: '10:00:00',
            departureTimeWindowTo: '12:00:00',
          },
        ],
        fare: {
          cabinClass: 'eco',
          isMixedCabin: true,
          mixedCabinClasses: {
            departureCabinClass: 'first',
            returnCabinClass: 'business',
          },
        },
        promotion: {
          code: '15ABF2C1FJ',
        },
      },
    },
  },
};

export const PlanReviewTestCurrentPlan: CurrentPlanModel = {
  cartId: 'TESTGETCART_VALID',
  planName: 'ABCD',
  creationPointOfSaleId: 'TYONH08AA',
  creationDate: '2100-11-11',
  planExpiryDate: '2100-11-11',
  planLastModificationDate: '2100-11-11T11:11:11',
  prebookExpiryDate: '2023-01-01T10:11:11',
  isUnsaved: false,
  isPrebooked: false,
};
